/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GroupingRuleCostAnomalyConfiguration {
    getFixupPrototypeFunction() { return GroupingRuleCostAnomalyConfiguration.fixupPrototype; }

    static newInstance(model: Partial<GroupingRuleCostAnomalyConfiguration>): GroupingRuleCostAnomalyConfiguration {
        let obj = Object.assign(new GroupingRuleCostAnomalyConfiguration(), model);
        GroupingRuleCostAnomalyConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GroupingRuleCostAnomalyConfiguration>): GroupingRuleCostAnomalyConfiguration {
        if (!model) return null;
        return GroupingRuleCostAnomalyConfiguration.newInstance(<GroupingRuleCostAnomalyConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GroupingRuleCostAnomalyConfiguration) {
        if (!obj) return;

        models.GroupingRuleCostAnomalyConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GroupingRuleCostAnomalyConfiguration): boolean {
        Object.setPrototypeOf(obj, GroupingRuleCostAnomalyConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.threshold) {
            models.GroupingRuleCostAnomalyThreshold.fixupPrototype(this.threshold);
        }
        if (this.notification) {
            models.GroupingRuleCostAnomalyNotification.fixupPrototype(this.notification);
        }
    }

    /**
     * Cost Anomaly Threshold for Grouping Rule
     */
    threshold: models.GroupingRuleCostAnomalyThreshold;

    /**
     * Cost Anomaly Notification Configuration for Grouping Rule
     */
    notification: models.GroupingRuleCostAnomalyNotification;

}
